import { render, staticRenderFns } from "./ProducersFarms_G.vue?vue&type=template&id=44d56fce"
import script from "./ProducersFarms_G.vue?vue&type=script&lang=js"
export * from "./ProducersFarms_G.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports